import React, { useState } from "react"
import Svg from "../_svgs/svg"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"

export default function LanguageSelector({ languages, useParkingLanguageSelection, langChoiceAriaLabel /*languageChoiceLabel*/ }) {
  const [isLanguageActive, setIsLanguageActive] = useState(false)
  const handleLanguageToggle = () => {
    setIsLanguageActive(!isLanguageActive)
  }

  return languages && languages.length > 0 ? (
    <div className={`main-navigation__item langselect js--has-dropdown ${isLanguageActive ? "is-dropped" : ""}`}>
      <OutsideClickTrigger onOutsideClick={() => setIsLanguageActive(false)}>
        <>
          {languages.map((lang, index) => {
            if (lang.selected) {
              return (
                <button
                  lang={lang.language}
                  key={index}
                  aria-expanded={isLanguageActive}
                  aria-haspopup="listbox"
                  aria-controls="language-list"
                  className="button button--nav js--dropdown-trigger"
                  onClick={() => handleLanguageToggle()}
                >
                  <img alt={`${(langChoiceAriaLabel && langChoiceAriaLabel + " ") || ""}${lang.text}`} src={lang.languageLogo}></img>
                  <Svg isDecorative={true} iconName={"arrowdownangle"} />
                </button>
              )
            }
            return
          })}

          <div className={`dropdown dropdown--language ${isLanguageActive ? "is-active" : ""}`}>
            {/* {languageChoiceLabel ? <h6>{languageChoiceLabel}</h6> : ""} */}
            <ul id="languageList" className={`dropdown__list js--dropdown-list${isLanguageActive ? "" : " v-hidden"}`} data-dropdowntargetid={2}>
              {useParkingLanguageSelection
                ? languages.map((lang, index) => {
                    if (!lang.selected) {
                      return (
                        <li className={`${isLanguageActive ? "" : "v-hidden d-none"} dropdown__item`} lang={lang.language} key={index}>
                          <a
                            aria-hidden={isLanguageActive ? "false" : "true"}
                            tabIndex={isLanguageActive ? "" : -1}
                            className={`button ${lang.selected ? "is-active" : ""}`}
                          >
                            <img
                              aria-hidden={isLanguageActive ? "false" : "true"}
                              tabIndex={isLanguageActive ? "" : -1}
                              alt={lang.text}
                              src={lang.languageLogo}
                            ></img>
                            <span tabIndex={-1} aria-hidden="true" className="langtext">
                              {lang.text}
                            </span>
                          </a>
                        </li>
                      )
                    }
                  })
                : languages.map((lang, index) => {
                    if (!lang.selected) {
                      return (
                        <li className={`${isLanguageActive ? "" : "v-hidden d-none"} dropdown__item`} lang={lang.language} key={index}>
                          <a
                            aria-hidden={isLanguageActive ? "false" : "true"}
                            tabIndex={isLanguageActive ? "" : -1}
                            href={lang.value}
                            className={`button ${lang.selected ? "is-active" : ""}`}
                          >
                            <img
                              aria-hidden={isLanguageActive ? "false" : "true"}
                              tabIndex={isLanguageActive ? "" : -1}
                              alt={lang.text}
                              src={lang.languageLogo}
                            ></img>
                            <span tabIndex={-1} aria-hidden="true" className="langtext">
                              {lang.text}
                            </span>
                          </a>
                        </li>
                      )
                    }
                  })}
            </ul>
          </div>
        </>
      </OutsideClickTrigger>
    </div>
  ) : (
    ""
  )
}
